import { w as writable } from "./index2.js";
const currentRoute = writable(null);
export {
  currentRoute as c
};
//# sourceMappingURL=route.js.map
